/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Add to Cart function (Vanilla JS)
function addToCart_Ajax(v_id, sell_id, callback) {
  const data = {
    items: [
      {
        id: v_id,
        quantity: 1,
        selling_plan: sell_id || null,
      },
    ],
  };
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json();
    })
    .then((result) => {
      console.log("Data added successfully:", result);
      if (callback && typeof callback === "function") {
        callback(result);
      }
    })
    .catch((error) => {
      console.error("Error adding data to cart:", error);
    });
}

function remove_Ajax(variantId, callback) {
  $.ajax({
    url: "/cart/change.js",
    method: "POST",
    data: {
      quantity: 0,
      id: variantId,
    },
    dataType: "json",
    success: function (response) {
      console.log("Product removed successfully");
      if (callback && typeof callback === "function") {
        callback();
      }
    },
    error: function (error) {
      console.error("Error removing product:", error.responseText);
    },
  });
}

// Delegated click handling for toggle buttons:
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.btn-toggle');
  if (!toggle) return;
  const card = toggle.closest('.product-card');
  const panelId = toggle.getAttribute('aria-controls');
  const panel = document.getElementById(panelId);
  if (!panel || !card) return;
  const isOpen = toggle.getAttribute('aria-expanded') === 'true';
  if (isOpen) {
    toggle.setAttribute('aria-expanded', 'false');
    card.classList.remove('open');
  } else {
    toggle.setAttribute('aria-expanded', 'true');
    card.classList.add('open');
  }
});

// Optional: close panel when pressing Escape if it is open
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.product-card.open').forEach(card => {
      const toggle = card.querySelector('.btn-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      card.classList.remove('open');
    });
  }
});

document.addEventListener("click", function (event) {
  // === Delegated tab click handler ===
  const tabTitle = event.target.closest(".cart_custom_tab .tab_title");
  if (tabTitle) {
    const index = tabTitle.getAttribute("data-tab-index");
    const tabTitles = document.querySelectorAll(".cart_custom_tab .tab_title");
    const tabContents = document.querySelectorAll(".cart_custom_tab .tab_data");
    tabTitles.forEach((t) => t.classList.remove("active"));
    tabContents.forEach((c) => c.classList.remove("active"));
    tabTitle.classList.add("active");
    const matchingContent = document.querySelector(`.cart_custom_tab .tab_data[data-tab-index="${index}"]`);
    if (matchingContent) matchingContent.classList.add("active");
    const titleList = document.querySelector(".cart_custom_tab .title_list");
    if (titleList) {
      titleList.className = titleList.className.replace(/\bactive_\d+\b/g, "").trim();
      titleList.classList.add(`active_${index}`);
    }
    return;
  }

  // === Delegated tab click handler ===
  const minicart_upsell_atc = event.target.closest(".mini_cart_recommendations .btn-add");
  if (minicart_upsell_atc) {
    const button = minicart_upsell_atc;

    if (button.disabled) return;
    const vID = button.dataset.varid || button.getAttribute('data-varid');
    const sellID = button.dataset.sellid || button.getAttribute('data-sellid') || null;
    const labelSpan = button.querySelector('span');
      
    if (!button.classList.contains('added')) {
      button.disabled = true;
      // make the callback async so we can use await inside it
      addToCart_Ajax(vID, sellID, async function () {
        try {
          labelSpan && (labelSpan.innerText = "Remove From Cart");
          button.classList.add("added");

          // fetch fresh cart JSON and dispatch the event
          const resp = await fetch(`${window.themeVariables.routes.cartUrl}.js`, { cache: 'reload' });
          const cartContent = await resp.json();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartContent } }));
        } catch (err) {
          console.error('Failed to refresh cart after add:', err);
        } finally {
          button.disabled = false;
        }
      });
    }
    if (button.classList.contains('added')) {
      button.disabled = true;

      remove_Ajax(vID, async function () {
        try {
          labelSpan && (labelSpan.innerText = "Add to Cart");
          button.classList.remove("added");

          const resp = await fetch(`${window.themeVariables.routes.cartUrl}.js`, { cache: 'reload' });
          const cartContent = await resp.json();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartContent } }));
        } catch (err) {
          console.error('Failed to refresh cart after remove:', err);
        } finally {
          button.disabled = false;
        }
      });
      
    }
    return;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".inventary-popup");
  const closeBtn = document.querySelector("[data-testid='social_proof_close']");

  if (popup) {
    setTimeout(() => {
      popup.style.display = "flex"; 
    }, 3000);

    setTimeout(() => {
      popup.style.display = "none";
    }, 10000); 

      if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        popup.style.display = "none";
      });
    }
  }
});

$(document).ready(function () {
    $(document).on("click",".checkbox-btn",function() {
    console.log('working')
    const $btn = $(this);
    const variantId = $btn.attr("v-id");
    const isChecked = !$btn.hasClass("checked");

    $btn.toggleClass("checked", isChecked);
    $btn.attr("aria-checked", isChecked);

    if (isChecked) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variantId,
          quantity: 1,
        },
        dataType: "json",
        success: function (response) {
          console.log("✅ Added to cart:", response);

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
        },
        error: function (xhr) {
          console.error("❌ Add to cart failed:", xhr.responseText);
        },
      });
    } else {
      $.getJSON("/cart.js", function (cart) {
        const item = cart.items.find((i) => i.variant_id == variantId);
        if (item) {
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: JSON.stringify({
              id: item.key,
              quantity: 0,
            }),
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
              console.log("🗑️ Removed from cart:", response);

              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
            },
            error: function (xhr) {
              console.error("❌ Remove failed:", xhr.responseText);
            },
          });
        }
      });
    }
  });
});

$(document).ready(function () {
  $('[cancel-modal-trigger]').click(function () {
    $('.cancel_popup').addClass('active');
    $('body').css('overflow', 'hidden');
  });

  $('.cancel_popup .popup_close, .cancel_popup .popup_overlay').click(function () {
    $('.cancel_popup').addClass('in_active');
    setTimeout(function () {
      $('.cancel_popup').removeClass('active in_active');
      $('body').css('overflow', 'auto');
    }, 300);
  });
});

// Diffusuer Kit JS

$(document).ready(function () {
  const $carousel = $('.million-wrap.multiple-items'); 

  function initOwl() {
    if ($carousel.hasClass('owl-loaded')) {
      $carousel.trigger('destroy.owl.carousel');
      $carousel.removeClass('owl-loaded');
      $carousel.find('.owl-stage-outer').children().unwrap();
    }

    $carousel.owlCarousel({
      items: 3,
      loop: true,
      margin: 20,
      dots: true,
      nav: false,
      autoplay: false,
      responsive: {
        0: { items: 1 },
        768: { items: 3 }
      }
    });
  }

  const imgs = $carousel.find('img');
  let loaded = 0;
  if (imgs.length) {
    imgs.each(function () {
      if (this.complete) {
        loaded++;
        if (loaded === imgs.length) initOwl();
      } else {
        $(this).on('load', function () {
          loaded++;
          if (loaded === imgs.length) initOwl();
        });
      }
    });
  } else {
    initOwl();
  }

  $(window).on('resize', function () {
    $carousel.trigger('refresh.owl.carousel');
  });

  document.addEventListener('shopify:section:load', function () {
    initOwl();
  });
});


$(document).ready(function () {
  $('#StickyAddToCart').on('click', function (e) {
    e.preventDefault();

    $(this)
      .attr('aria-busy', 'true')
      .attr('disabled', true);

    $('#AddToCart').trigger('click');
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.attributeName === 'aria-busy' &&
        $('#AddToCart').attr('aria-busy') !== 'true'
      ) {
        $('#StickyAddToCart')
          .removeAttr('aria-busy')
          .removeAttr('disabled');
      }
    });
  });

  observer.observe(document.querySelector('#AddToCart'), {
    attributes: true,
  });


});



function setupModal(modalId, openBtnId, closeBtnId, onOpen) {
    const modal = document.getElementById(modalId);
    const openBtn = document.getElementById(openBtnId);
    const closeBtn = document.getElementById(closeBtnId);
    if (!modal) return;

    let scrollPosition = 0;

    const open = () => {
        // Store scroll position
        scrollPosition = window.pageYOffset;

        modal.classList.add('show');
        document.body.classList.add('modal-open');

        // Lock body scroll
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';

        // Prevent touchmove on mobile
        document.addEventListener('touchmove', preventScroll, {
            passive: false
        });

        requestAnimationFrame(() => {
            onOpen && onOpen();
        });
    };

    const close = () => {
      modal.classList.remove('show');
      document.body.classList.remove('modal-open');

      // Unlock body scroll
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';

      // Force disable smooth scrolling temporarily
      const htmlScrollBehavior = document.documentElement.style.scrollBehavior;
      const bodyScrollBehavior = document.body.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';

      // Use direct property assignment instead of scrollTo
      document.documentElement.scrollTop = scrollPosition;
      document.body.scrollTop = scrollPosition; // Fallback for some browsers

      // Restore original scroll behavior after a tiny delay
      setTimeout(() => {
         document.documentElement.style.scrollBehavior = htmlScrollBehavior;
         document.body.style.scrollBehavior = bodyScrollBehavior;
      }, 10);

      // Re-enable touchmove
      document.removeEventListener('touchmove', preventScroll);
   };

   const preventScroll = (e) => {
      // Allow scrolling inside modal content
      if (!e.target.closest('.modal-content')) {
         e.preventDefault();
      }
   };

   openBtn && openBtn.addEventListener('click', open);
   closeBtn && closeBtn.addEventListener('click', close);
   modal.addEventListener('click', (e) => {
      if (e.target === modal) close();
   });

   document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('show')) close();
   });

   return {
      open,
      close
   };
}

function initSizeGuideModal() {
(function () {
   const sizeGuideModal = document.getElementById('sizeGuideModal');
   if (!sizeGuideModal) return;

   const tabs = sizeGuideModal.querySelectorAll('.modal-size-tab');
   const heroImg = document.getElementById('modalSizeImage');

   function setSize(size) {
      const activeTab = sizeGuideModal.querySelector(`.modal-size-tab[data-size="${size}"]`);
      if (!activeTab) return;

      const imgUrl = activeTab.dataset.sizeImg;
      if (heroImg && imgUrl) heroImg.src = imgUrl;

      // Toggle tab active states
      tabs.forEach(t => t.classList.toggle('active', t.dataset.size === size));

      // Toggle card active states (cards not clickable)
      const cards = sizeGuideModal.querySelectorAll('.size-card');
      cards.forEach(c => c.classList.toggle('active', c.dataset.size === size));
   }

   // Only tabs are clickable
   tabs.forEach(tab => {
      tab.addEventListener('click', () => setSize(tab.dataset.size));
   });

   // Set default to medium
   setSize('medium');
})();




}

// Puppy pad pdp page
setupModal('offerModal', 'offerInfoLink', 'offerModalCloseBtn');
setupModal('sizeGuideModal', 'sizeGuideLink', 'sizeModalCloseBtn');
setupModal('giftModal', 'giftBanner', 'giftModalCloseBtn');
setupModal('dogTrainingModal', 'gift-1', 'dogTrainingModalClose');
setupModal('shippingModal', 'gift-2', 'shippingModalClose');
setupModal('dogBallModal', 'gift-3', 'dogBallModalClose');
initSizeGuideModal();


// document.addEventListener("DOMContentLoaded", () => {
//   const offerBundleBlock = document.querySelector(".custom_offer_bundle_block");
//   if (offerBundleBlock) initOfferOptions(offerBundleBlock);
// });

// function initOfferOptions(block) {
//   const offerOptions = block.querySelectorAll(".offer-option");
//   const productIdInput = document.querySelector(
//     '.product-form__buy-buttons input[name="id"]'
//   );

//   if (!productIdInput) return;

//   // Update product form ID from active offer
//   function updateProductVariantId() {
//     const activeOffer = block.querySelector(".offer-option.active");
//     if (!activeOffer) return;

//     const variantSelect = activeOffer.querySelector(".offer-variant");
//     if (!variantSelect) return;

//     productIdInput.value = variantSelect.value;
//   }

//   // Offer option click
//   offerOptions.forEach(option => {
//     option.addEventListener("click", () => {
//       offerOptions.forEach(opt => opt.classList.remove("active"));
//       option.classList.add("active");

//       updateProductVariantId();
//     });

//     // Variant change inside offer
//     const variantSelect = option.querySelector(".offer-variant");
//     if (variantSelect) {
//       variantSelect.addEventListener("change", updateProductVariantId);
//     }
//   });

//   // ✅ Auto-select "6 PuppyPads" on load
//   const defaultOption = block.querySelector(
//     '.offer-option[data-offer-name="6 PuppyPads"]'
//   );

//   if (defaultOption) {
//     defaultOption.click();
//   } else {
//     // Fallback: use already active offer
//     updateProductVariantId();
//   }
// }

 const swatchOption = document.querySelector('.block-swatch.Large .block-swatch__item');
 if(swatchOption){

   swatchOption.click();
 }

document.addEventListener("DOMContentLoaded", () => {
  const offerBundleBlock = document.querySelector(".custom_offer_bundle_block");
  if (offerBundleBlock) initOfferOptions(offerBundleBlock);
});

function initOfferOptions(block) {
  const offerOptions = block.querySelectorAll(".offer-option");
  const productIdInput = document.querySelector(
    '.product-form__buy-buttons input[name="id"]'
  );

  const gift3Inputs = document.querySelectorAll(
    '#gift-3 .free_product_input'
  );

  const gift1 = document.getElementById("gift-1");
  const gift2 = document.getElementById("gift-2");
  const gift3 = document.getElementById("gift-3");
  const gift1Text = document.getElementById("gift1-text");
  const gift2Text = document.getElementById("gift2-text");
  const gift3Text = document.getElementById("gift3-text");
  const progressFill = document.getElementById("progress-fill");
   const addToCartPrice = document.querySelector("#AddToCart .product-form-price");

  if (!productIdInput) return;

  // 🔄 Update product form ID from active offer
  function updateProductVariantId() {
    const activeOffer = block.querySelector(".offer-option.active");
    if (!activeOffer) return;

    const variantSelect = activeOffer.querySelector(".offer-variant");
    if (!variantSelect) return;

    productIdInput.value = variantSelect.value;
  }

  // 🎁 Gift unlock + progress logic
  function updateGift3State() {
    const activeOffer = block.querySelector(".offer-option.active");
    if (!activeOffer) return;

    const offerName = activeOffer.dataset.offerName;

    // Reset
    gift1.classList.remove("unlocked");
    gift2.classList.remove("unlocked");
    gift3.classList.remove("unlocked");
    gift1Text.classList.remove("hidden");
    gift2Text.classList.remove("hidden");
    gift3Text.classList.remove("hidden");


    // Default disable Gift-3 inputs
    gift3Inputs.forEach(input => input.disabled = true);

    if (offerName == "1 PUPPYPAD") {
      gift1.classList.add("unlocked");
      progressFill.style.width = "33%";
      gift2Text.classList.add("hidden");
      gift3Text.classList.add("hidden");
      
    }

    if (offerName == "6 PuppyPads") {
      gift1.classList.add("unlocked");
      gift2.classList.add("unlocked");
      gift3.classList.add("unlocked");
      gift1Text.classList.add("hidden");
      gift3Text.classList.add("hidden");
      gift3Inputs.forEach(input => input.disabled = false);
      progressFill.style.width = "100%";
    }

    if (offerName == "3 PuppyPads") {
      gift1.classList.add("unlocked");
      gift2.classList.add("unlocked");
      progressFill.style.width = "66%";
      gift1Text.classList.add("hidden");
      gift2Text.classList.add("hidden");
    }

    
  }

   // 💲 Update Add to Cart button price
  function updateAddToCartPrice() {
    const activeOffer = block.querySelector(".offer-option.active");
    if (!activeOffer) return;

    const offerPrice = activeOffer.dataset.price;
    if (offerPrice) {
      addToCartPrice.textContent = offerPrice;
    }
  }

  // Offer option click
offerOptions.forEach(option => {
  option.addEventListener("click", () => {
    offerOptions.forEach(opt => opt.classList.remove("active"));
    option.classList.add("active");

    const offerName = option.getAttribute("data-your-offer");

    const wrapper = option.closest(".offer-selector-section");
    if (wrapper) {
      const textEl = wrapper.querySelector("#selectedOfferText");
      if (textEl) {
        textEl.textContent = offerName;
      }
    }

    updateProductVariantId();
    updateGift3State();
    updateAddToCartPrice();
  });

  const variantSelect = option.querySelector(".offer-variant");
  if (variantSelect) {
    variantSelect.addEventListener("change", updateProductVariantId);
  }
});

  // // ✅ Auto-select "6 PuppyPads" on load
  const defaultOption = block.querySelector(
    '.offer-option[data-offer-name="6 PuppyPads"]'
  );


  if (defaultOption) {
    defaultOption.click();
      
  } else {
    updateProductVariantId();
    updateGift3State();
    updateAddToCartPrice();
  }
}



const progressBar = document.getElementById('progressBar');
const stockInfo = document.getElementById('stockInfo');
const previousMonthNameEl = document.getElementById('previousMonthName');
const currentMonthNameEl = document.getElementById('currentMonthName');
const previousMonthInfoEl = document.getElementById('previousMonthInfo');

if (progressBar && stockInfo && previousMonthNameEl && currentMonthNameEl) {
   const monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
      "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
   ];
   const now = new Date();
   const currentMonthIndex = now.getMonth();
   const previousMonthIndex = (currentMonthIndex - 1 + 12) % 12;

   currentMonthNameEl.textContent = monthNames[currentMonthIndex];
   previousMonthNameEl.textContent = monthNames[previousMonthIndex];

   const total = 5400;
   let sold = Math.floor(total * 0.83);
   let percentage = (sold / total) * 100;
   const prevMonthSold = 4780;

   if (previousMonthInfoEl) {
      previousMonthInfoEl.textContent = `Sold Out (${prevMonthSold.toLocaleString('en-US')} PetHealth Were Sold)`;
   }

   const updateStock = () => {
      const currentMonthBar = document.querySelector('.current-month-bar');
      progressBar.classList.remove('pulse');
      void progressBar.offsetHeight;
      progressBar.classList.add('pulse');
      stockInfo.classList.remove('updating');
      void stockInfo.offsetHeight;
      stockInfo.classList.add('updating');
      if (currentMonthBar) {
         currentMonthBar.classList.remove('highlight');
         void currentMonthBar.offsetHeight;
         currentMonthBar.classList.add('highlight');
      }
      progressBar.style.width = `${percentage}%`;
      stockInfo.textContent = `${Math.floor(percentage)}% Sold (${sold.toLocaleString('en-US')} out of ${total.toLocaleString('en-US')} PuppyPads)`;
      setTimeout(() => {
         progressBar.classList.remove('pulse');
         stockInfo.classList.remove('updating');
         if (currentMonthBar) currentMonthBar.classList.remove('highlight');
      }, 600);
   };

   const stockInterval = setInterval(() => {
      const activeOffer = document.querySelector('.offer-option.active');
      let increment = 1;
      if (activeOffer) {
         const offerName = activeOffer.dataset.offerName;
         if (offerName === 'Buy 3 Get 3 Free') increment = 6;
         else if (offerName === 'Buy 2 Get 1 Free') increment = 3;
      }
      const maxSold = Math.floor(total * 0.99);
      if (sold + increment <= maxSold) {
         sold += increment;
         percentage = (sold / total) * 100;
         updateStock();
      } else if (sold < maxSold) {
         sold = maxSold;
         percentage = 99;
         updateStock();
         clearInterval(stockInterval);
      } else {
         clearInterval(stockInterval);
      }
   }, 12000);

   progressBar.style.width = `${percentage}%`;
   stockInfo.textContent = `${Math.floor(percentage)}% Sold (${sold.toLocaleString('en-US')} out of ${total.toLocaleString('en-US')} PetHealth)`;
}

document.addEventListener('DOMContentLoaded', function () {
  if (template_name == 'puppypad') {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count > 0) {
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(() => {
            console.log('Cart cleared');
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
            }));
          });
        }
      });

  }
});


// document.addEventListener('cart:updated', async function(event) {
//   if (window.themeVariables.settings.pageType !== "cart") return;

//   const lineItems = document.querySelectorAll('tbody.line-item-table__list tr.line-item');
//   const keysToRemove = [];

//   // First, collect all parent and child keys
//   lineItems.forEach(parentItem => {
//     const isParent = parentItem.getAttribute('data-parent') === "true";
//     if (!isParent) return;

//     const parentTime = parentItem.getAttribute('data-time');
//     const parentKey = parentItem.getAttribute('data-key');

//     keysToRemove.push(parentKey); // mark parent for removal

//     lineItems.forEach(childItem => {
//       const isChild = childItem.getAttribute('data-parent') === "false";
//       const childTime = childItem.getAttribute('data-time');
//       const childKey = childItem.getAttribute('data-key');

//       if (isChild && childTime === parentTime) {
//         keysToRemove.push(childKey); // mark child for removal
//       }
//     });
//   });

//   // Remove items one by one (await ensures proper sequence)
//   for (const key of keysToRemove) {
//     await removeLineItem(key);
//   }
// });

// // Remove item function using fetch API
// function removeLineItem(key) {
//   const url = `${window.themeVariables.routes.cartChangeUrl}.js`;

//   return fetch(url, {
//     method: 'POST',
//     credentials: 'same-origin',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ id: key, quantity: 0 })
//   })
//   .then(res => res.json())
//   .catch(err => console.error("Error removing item:", err));
// }



document.addEventListener('cart:updated', async function(event) {
  if (window.themeVariables.settings.pageType !== "cart") return;

  const lineItems = document.querySelectorAll('tbody.line-item-table__list tr.line-item');
  const keysToRemove = [];

  // Collect all parent and child keys
  lineItems.forEach(parentItem => {
    const isParent = parentItem.getAttribute('data-parent') === "true";
    if (!isParent) return;

    const parentTime = parentItem.getAttribute('data-time');
    const parentKey = parentItem.getAttribute('data-key');

    keysToRemove.push(parentKey); // mark parent for removal

    lineItems.forEach(childItem => {
      const isChild = childItem.getAttribute('data-parent') === "false";
      const childTime = childItem.getAttribute('data-time');
      const childKey = childItem.getAttribute('data-key');

      if (isChild && childTime === parentTime) {
        keysToRemove.push(childKey); // mark child for removal
      }
    });
  });

  // Remove items one by one (await ensures proper sequence)
  for (const key of keysToRemove) {
    await removeLineItem(key);
  }

  // Reload page after all removals are done
  window.location.reload();
});

// Remove item function using fetch API
function removeLineItem(key) {
  const url = `${window.themeVariables.routes.cartChangeUrl}.js`;

  return fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(res => res.json())
  .catch(err => console.error("Error removing item:", err));
}




document.addEventListener("DOMContentLoaded", function () {
    const OFFSET = 120; // 👈 header + announcement height (adjust if needed)
    document.querySelectorAll(".button-wrapper .button").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        const target = document.querySelector("#pdp_main_section");
        if (!target) return;

        const targetPosition =
          target.getBoundingClientRect().top + window.pageYOffset - OFFSET;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      });
    });
  });






  


$(document).on(
  "change click",
  '.mini-cart.drawer .shipping_protection .switch input[type="checkbox"]',
  function (e) {
    // alert();
    console.log("fjdsfsdfb---------------");
    var $input = $(this);
    var $label = $input.closest(".switch"); // the label wrapper
    if (!$label.length) return;

    // prevent double actions
    if ($label.prop("disabled")) {
      // if disabled, revert checkbox to previous state (optional)
      $input.prop("checked", !$input.prop("checked"));
      return;
    }

    $label.prop("disabled", true);
    $label.addClass("c_loading");
    if ($label.find(".custom_loader").length === 0) {
      $label.append('<div class="custom_loader"></div>');
    }

    // get variant id from data attribute on the label
    var ship_pro_var = $label.attr("data-varid") || $label.data("varid");
    if (!ship_pro_var) {
      cleanup();
      return;
    }

    // decide which sections to request (same logic as before)
    var tpl = (typeof window.template_name !== "undefined" ? String(window.template_name) : "").trim();
    var sections_data = ["mini-cart"];
    if (tpl === "cattasaurus" || tpl === "cattasaurus_p9") sections_data = ["if_cattasaurus_mini_cart"];

    // helper: dispatch result
    function dispatchCartRefresh(cartData) {
      try {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            detail: { cart: cartData },
            bubbles: true,
          })
        );
      } catch (err) {
        console.error("dispatchCartRefresh error", err);
      }
    }

    // remove helper: find line index for the variant and call change API
    function removeVariantByVariantId(variantId) {
      // fetch cart to find the line number
      return $.getJSON("/cart.js").then(function (cart) {
        if (!cart || !Array.isArray(cart.items))
          return $.Deferred().reject("invalid-cart");

        var idx = -1;
        for (var i = 0; i < cart.items.length; i++) {
          if (
            String(cart.items[i].variant_id) === String(variantId) ||
            String(cart.items[i].id) === String(variantId)
          ) {
            idx = i + 1; // shopify line is 1-based
            break;
          }
        }

        if (idx === -1) {
          return $.Deferred().reject("variant-not-in-cart");
        }

        // POST to change endpoint: use theme variable if available
        var changeUrl =
          window.themeVariables &&
          window.themeVariables.routes &&
          window.themeVariables.routes.cartChangeUrl
            ? window.themeVariables.routes.cartChangeUrl + ".js"
            : "/cart/change.js";

        var payload = { line: idx, quantity: 0, sections: sections_data };

        return $.ajax({
          type: "POST",
          url: changeUrl,
          data: JSON.stringify(payload),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
      });
    }

    // add helper: call /cart/add.js with sections
    function addVariant(variantId) {
      var payload = { quantity: 1, id: variantId, sections: sections_data };
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify(payload),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
      });
    }

    // cleanup UI (enable, remove loader)
    function cleanup() {
      $label.prop("disabled", false);
      $label.removeClass("c_loading");
      $label.find(".custom_loader").remove();
    }

    // Decide action based on checked state
    if ($input.prop("checked")) {
      // turned ON -> add
      addVariant(ship_pro_var)
        .done(function (resp) {
          // resp should be cart JSON or item — some themes return cart JSON in different shape.
          // If your add endpoint returns the new cart section HTML in resp.sections, dispatch that
          if (resp && resp.sections) {
            // if server returns sections HTML, try to parse or pass to other handlers via cart:refresh
            dispatchCartRefresh(resp);
          } else {
            // else fetch cart and dispatch
            $.getJSON("/cart.js").done(dispatchCartRefresh);
          }
        })
        .fail(function (err) {
          console.error("Failed to add shipping product:", err);
          // revert checkbox visually if add failed
          $input.prop("checked", false);
          // show error near control
          $(".warning").remove();
          var msg = "Failed to add shipping protection.";
          try {
            if (err && err.responseJSON && err.responseJSON.description)
              msg = err.responseJSON.description;
          } catch (e) {}
          $label.after('<p class="warning">' + msg + "</p>");
        })
        .always(cleanup);
    } else {
      // turned OFF -> remove (change quantity to 0)
      removeVariantByVariantId(ship_pro_var)
        .done(function (resp) {
          if (resp && resp.sections) {
            dispatchCartRefresh(resp);
          } else {
            $.getJSON("/cart.js").done(dispatchCartRefresh);
          }
        })
        .fail(function (err) {
          console.error("Failed to remove shipping product:", err);
          // revert checkbox visually if remove failed
          $input.prop("checked", true);
          $(".warning").remove();
          var msg = "Failed to remove shipping protection.";
          try {
            if (typeof err === "string") msg = err;
            else if (err && err.responseJSON && err.responseJSON.description)
              msg = err.responseJSON.description;
          } catch (e) {}
          $label.after('<p class="warning">' + msg + "</p>");
        })
        .always(cleanup);
    }
  }
);






function cartHasOnlyFreeProducts(cart) {
  if (!cart || !cart.items || cart.items.length === 0) return false;
  return cart.items.every((item) => cart_free_item.includes(item.product_id));
}

async function clearCartAndRefresh() {
  try {
    const res = await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    const clearedCart = await res.json();
    setTimeout(function() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: clearedCart } }));
    }, 500);
    console.log("🧹 Cart cleared (only free products were present)", clearedCart);
  } catch (err) {
    console.error("Failed to clear cart", err);
  }
}

//IF CART HAS OnLy THIS 2 Products They are Automated Clear.
const cart_free_item = [9977342591274, 9981576184106, 50964975092010];

// Intercept all fetch calls
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  const url = args[0];
  if (
    typeof url === "string" &&
    (url.includes("/cart/change") ||
      url.includes("/cart/add") ||
      url.includes("/cart/update") ||
      url.includes("/cart.js"))
  ) {
    const cloned = response.clone();
    try {
      const cartData = await cloned.json();
      // 🚨 PRODUCT-ID check (NOT variant ID)
      if (cartHasOnlyFreeProducts(cartData)) {
        console.warn("⚠️ Cart has ONLY free products → clearing cart");
        await clearCartAndRefresh();
      }
    } catch (err) {
      console.warn("Unable to parse cart json", err);
    }
  }
  return response;
};


function isCart() {
  return document.URL.includes("/cart");
}


$(document).on("click", ".link.main-product--true", function (event) {
  event.preventDefault();
  const $this = $(this);
  const mainItem = $this.closest(".cart__item");
  mainItem
    .find(".line-item__loader, .line-item__loader-spinner")
    .removeAttr("hidden");
  const mainLineId = String($this.data("line-id"));
  const mainQuantity = parseInt(mainItem.attr("line-item-quantity"), 10) || 0;
  console.log(mainLineId);
  
  let giftMultiplier = 1;


  const totalGiftToRemove = mainQuantity * giftMultiplier;
  const updates = {};

  updates[mainLineId] = 0;
  mainItem.addClass("is-removed");

mainItem.find(".cart__item__meta input.freegiftId").each(function () {
  const giftLineId = $(this).val();
  if (giftLineId) {
    const giftItem = $(`.cart__item[data-line-id="${giftLineId}"]`);
    const currentGiftQty =
      parseInt(giftItem.find('input[name="updates[]"]').val(), 10) || 0;

    let quantityToRemove = totalGiftToRemove;
    let newGiftQty = Math.max(0, currentGiftQty - quantityToRemove);

    updates[giftLineId] = newGiftQty;

    if (newGiftQty === 0) {
      giftItem.addClass("is-removed");
    }
  }
});

console.log(updates)


  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => response.json())
    .then((dataResponse) => {

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );

      $("#mini-cart").removeClass("is-loading");
    })
    .catch((error) => {
      console.error("Error:", error);
      $("#mini-cart").removeClass("is-loading");
    });
});


function increaseQuantity(event) {
  var updates = { updates: {} };

  var $currentLineItem = $(event).closest(".cart__item");
  var $metaProperties = $currentLineItem.find(".cart__item__info");
  var $quantityInput = $currentLineItem.find(".quantity-selector__input");
  var currentQuantity = parseInt($quantityInput.val(), 10) || 0;
  var newQuantity = currentQuantity + 1;

  $quantityInput.val(newQuantity);

  var mainProductLineId = $(event).data("line-id");
  updates.updates[mainProductLineId] = newQuantity;

  if ($metaProperties.find("input.freegiftId").length > 0) {
    $metaProperties.find("input.freegiftId").each(function () {
      const giftLineId = $(this).val();
      if (!giftLineId) return;

      const giftItem = $(`.cart__item[data-line-id="${giftLineId}"]`);

      updates.updates[giftLineId] = newQuantity;

      giftItem.find('input[name="updates[]"]').val(newQuantity);
    });
  }

  cartUpdated(updates);
  console.log("updates", JSON.stringify(updates));
}




function decreaseQuantity(event) {
  var updates = { updates: {} };

  var $currentLineItem = $(event).closest(".cart__item");
  var $metaProperties = $currentLineItem.find(".cart__item__info");
  var $quantityInput = $currentLineItem.find(".quantity-selector__input");
  var currentQuantity = parseInt($quantityInput.val(), 10) || 0;
  var newQuantity = Math.max(0, currentQuantity - 1);

  $quantityInput.val(newQuantity);

  var mainProductLineId = $(event).data("line-id");
  updates.updates[mainProductLineId] = newQuantity;

  if ($metaProperties.find("input.freegiftId").length > 0) {
    $metaProperties.find("input.freegiftId").each(function () {
      const giftLineId = $(this).val();
      if (!giftLineId) return;

      const giftItem = $(`.cart__item[data-line-id="${giftLineId}"]`);

      updates.updates[giftLineId] = newQuantity;

      giftItem.find('input[name="updates[]"]').val(newQuantity);
    });
  }

    cartUpdated(updates);
  console.log("updates", JSON.stringify(updates));
}


function cartUpdated(updates) {
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  })
    .then((response) => {
      if (response.ok) {
        return response.json().then((dataResponse) => {
          $("#mini-cart").removeClass("is-loading");
          
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
        });
      } else {
        console.log(response);
        $("#mini-cart").removeClass("is-loading");
        throw new Error("Error updating cart");
      }
    })
    .catch((error) => {
      $("#mini-cart").removeClass("is-loading");
      console.error("Error:", error);
    });
}

$(document).on("click", ".quantity-selector__button.minus", function (event) {
  $("#mini-cart").addClass("is-loading");
  decreaseQuantity($(this));
});

$(document).on("click", ".quantity-selector__button.plus", function (event) {
  $("#mini-cart").addClass("is-loading");
  increaseQuantity($(this));
});



(function () {
  const KEY = 'puppypad_force_clear';

  function shouldClear() {
    return window.location.href.toLowerCase().includes('puppypad');
  }

  function clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true
    }).then(() => {
      console.log('Cart cleared (puppypad)');
    }).catch(() => {});
  }

  // Mark intent BEFORE leaving the page
  window.addEventListener('pagehide', function () {
    if (shouldClear()) {
      sessionStorage.setItem(KEY, '1');
    }
  });

  // Run on return (works with bfcache)
  window.addEventListener('pageshow', function () {
    if (shouldClear() && sessionStorage.getItem(KEY) === '1') {
      sessionStorage.removeItem(KEY);
      clearCart();
    }
  });

  // Fallback for aggressive browsers
  document.addEventListener('visibilitychange', function () {
    if (
      document.visibilityState === 'visible' &&
      shouldClear()
    ) {
      clearCart();
    }
  });
})();

